import AsyncStorage from '@react-native-async-storage/async-storage'
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE
} from 'redux-persist';
import alertReducer from './alert/alertReducer';
import empresaReducer from './empresa/empresaReducer';
import pedidoReducer from './pedido/pedidoReducer';
import sessaoReducer from './sessao/sessaoReducer';
import snackReducer from './snack/snackReducer';
import empresasReducer from './empresas/empresasReducer';
import { APP_NAME } from '../shared/constants';

// import {AppState} from './types';

export const rootReducer = combineReducers({
  snack: snackReducer,
  alert: alertReducer,
  pedido: pedidoReducer,
  sessao: sessaoReducer,
  empresa: empresaReducer,
  empresas: empresasReducer
});
export type RootAppState = ReturnType<typeof rootReducer>;

const persistConfig = {
  key: `PERSIST_${APP_NAME}`,
  storage: AsyncStorage,
  blacklist: ['snack', 'alert', 'empresa', 'empresas']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
    }
  })
});
export const persistor = persistStore(store);

export default store;
